<template>
<div class="container-fluid">
  <div class="row bandeauTitre">
    <div class="col-lg-11 col-sm-11 col-10">
      <span class="text-left titre"><a href="/">Why<span class="lettreTitre"><b>Note</b></span></a></span>
    </div>
    <div class="col-lg-1 col-sm-1 col-2"></div>
  </div>
  <div class="row">
    <div class="col-lg-4 col-sm-4 col-1"></div>
      <div class="col-lg-4 col-sm-4 col-10">
        <div class="row">
          <span class="sousTitre"><b>Connexion</b></span>
          <hr>
        </div>
        <div class="row">
          <div class="formulaire">
            <div v-if="hasErrors" class="erreurConnection px-4 py-3 rounded relative mb-3" role="alert">
              <span class="block sm:inline">Adresse email ou mot de passe incorrect.</span>
            </div>

            <form @submit.prevent="login" class="bg-white shadow-md rounded border-indigo border-t-4 px-8 pt-6 pb-8 mb-4">
              <div class="mb-4 text-center">
                <label class="block text-grey-darker text-sm font-bold mb-2 textConnection" for="username">
                  <i>Adresse mail</i>
                </label>
                <input v-model="email" class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" id="username" type="email" placeholder="Email" autofocus>
              </div>

              <div class="mb-6 text-center">
                <label class="block text-grey-darker text-sm font-bold mb-2 textConnection" for="password">
                  <i>Mot de passe</i>
                </label>
                <input v-model="password" class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" id="password" type="password" placeholder="Password">
              </div>

              <div class="flex items-center justify-between boutonConnection">
                <b-button variant="primary" type="submit" :disabled="this.isDisabled" :class="{ 'opacity-50 cursor-not-allowed': this.isDisabled }" class="colorButtonConnexion">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin fa-fw"></i>
                  Connexion
                </b-button>
              </div>
            </form>
          </div>
        </div>
      <div class="col-lg-4 col-sm-4 col-1"></div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: '',
      password: '',
      isLoading: false,
      hasErrors: false
    }
  },

  computed: {
    isDisabled () {
      return this.email.length === 0 || this.password.length === 0
    }
  },

  methods: {
    login () {
      if (this.isDisabled) {
        return false
      }

      this.isLoading = true
      this.hasErrors = false

      axios
        .post('/login', {
          'email': this.email,
          'password': this.password
        })
        .then(response => {
          this.isLoading = false
          this.$store.dispatch('login', response.data)
        })
        .catch(error => {
          this.isLoading = false
          this.hasErrors = true
          this.password = ''
        })
    }
  }
}
</script>

<style scoped>
  .bandeauTitre {
    background-color: blueviolet;
    color: cornsilk;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .titre {
    padding-left: 10%;
    font-size: 3vw;
    color: cornsilk;
  }

  .titre a {
    color: cornsilk;
  }

  .formulaire {
    margin-left: auto;
    margin-right: auto;
  }

  .connection {
    border-style: solid;
    border-color:white;
    border-radius: 10px;
    border-width: 2px;
    width: 40%;
    margin-left: auto;
    margin-right: auto;
  }

  hr {
    width: 100%;
    color: #F00;
  }

  .sousTitre {
    margin-top: auto;
    margin-bottom: auto;
    color: #8a2be2;
  }

  .textConnection {
    padding-right: 15px;
  }

  .boutonConnection {
    text-align: center;
    margin-top: 30px;
  }

  .erreurConnection {
    color: white;
    background-color: red;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .colorButtonConnexion {
    color: black;
    background-color:white;
    border-color: blueviolet;
  }

  .lettreTitre {
    color: #e0da1b;
  }

  @media screen and (max-width: 600px) {
    .titre {
      font-size: 8vw;
    }

    .sousTitre {
      font-size: 3.5vw;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    .titre {
      font-size: 4vw;
    }

    .sousTitre {
      font-size: 2vw;
    }
  }

  @media screen and (min-width: 1024px) {
    .titre {
      font-size: 2vw;
    }

    .sousTitre {
      font-size: 1vw;
    }
  }
</style>
